import React, { useState, useEffect } from 'react';
import { Container, Header, Segment, List, Divider, Button, Modal, Image } from 'semantic-ui-react';
import { useNavigate } from "react-router-dom";
import '@styles/BlogBody.css';
import '@styles/GeneralTheme.css';
import WebToLead from '@components/WebToLead'; // Import the WebToLead component
import CategoryGrid from '@components/CategoryGrid';
import ServicesCalculator from '@components/ServicesCalculator';

const message = 'Let\'s build an Empire together.';

const Service = () => {
  const navigate = useNavigate();
  const [modalOpen, setModalOpen] = useState(false); // State to manage modal visibility
  const [isDesktop, setIsDesktop] = useState(window.innerWidth > 768);

  useEffect(() => {
    const handleResize = () => {
      setIsDesktop(window.innerWidth > 768);
    };
    
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // Add Open Graph meta tags for service page
  useEffect(() => {
    const updateMetaTag = (property, content, isProperty = true) => {
      const attribute = isProperty ? 'property' : 'name';
      let metaTag = document.querySelector(`meta[${attribute}="${property}"]`);
      
      if (!metaTag) {
        metaTag = document.createElement('meta');
        metaTag.setAttribute(attribute, property);
        document.head.appendChild(metaTag);
      }
      metaTag.setAttribute('content', content);
    };

    document.title = 'Services - Cloud CZR | Salesforce Development & Technology Consulting';
    updateMetaTag('og:title', 'Services - Cloud CZR | Salesforce Development & Technology Consulting');
    updateMetaTag('og:description', 'Professional Salesforce development, custom software solutions, system integrations, and technology consulting services. Licensed and insured.');
    updateMetaTag('og:url', window.location.href);
    updateMetaTag('og:type', 'website');
    updateMetaTag('og:image', `${window.location.origin}/assets/CloudChiRho.png`);
    updateMetaTag('og:image:alt', 'Cloud CZR, Cloudczr, cloudczr.com');
    
    updateMetaTag('description', 'Professional Salesforce development, custom software solutions, system integrations, and technology consulting services. Licensed and insured.', false);
    updateMetaTag('twitter:title', 'Services - Cloud CZR | Salesforce Development & Technology Consulting', false);
    updateMetaTag('twitter:description', 'Professional Salesforce development, custom software solutions, system integrations, and technology consulting services. Licensed and insured.', false);
  }, []);

  const getTextStyle = () => ({
    color: '#a9885c',
    fontSize: isDesktop ? '1.2em' : '1em',
    lineHeight: isDesktop ? '1.6' : '1.4'
  });

  const handleOpenModal = () => {
    setModalOpen(true);
  };

  const handleCloseModal = () => {
    setModalOpen(false);
  };

  const categories = [
    {
      title: "Our Services",
      description: "Explore our professional services.",
      icon: "cogs",
      color: "#702963",
    },
    {
      title: "How We Help",
      description: "See how we assist our clients.",
      icon: "handshake",
      color: "#702963",
    },
    {
      title: "Technical Expertise",
      description: "Our technical skills and knowledge.",
      icon: "code",
      color: "#702963",
    },
  ];

  return (
    <Container fluid style={{ marginTop: '2em', padding: '0 2em', maxWidth: 'none !important', width: '100% !important' }}>
      <Header as='h1' textAlign='center' style={{ color: '#a9885c' }}>
        <Image src={`${process.env.PUBLIC_URL}/assets/services.svg`} alt="Cloud CZR, Cloudczr, cloudczr.com" style={{ width: isDesktop ? '50%' : '100%', height: 'auto', margin: '0 auto 15px auto', display: 'block' }} />
      </Header>

      <CategoryGrid categories={categories} onItemClick={(category) => navigate(`/${category.title.toLowerCase().replace(/\s+/g, '-')}`)} />

      <ServicesCalculator />

      <Divider section />

      {/* Contact Form Modal */}
      <Modal open={modalOpen} onClose={handleCloseModal} size='small' style={{ backgroundColor: '#702963' }}>
        <Modal.Header style={{ backgroundColor: '#702963', color: '#a9885c' }}>Contact Us</Modal.Header>
        <Modal.Content style={{ backgroundColor: '#a9885c' }}>
          <WebToLead />
        </Modal.Content>
        <Modal.Actions style={{ backgroundColor: '#702963', color: '#a9885c' }}>
          <Button style={{ backgroundColor: '#a9885c', color: '#702963' }} onClick={handleCloseModal}>Close</Button>
        </Modal.Actions>
      </Modal>
    </Container>
  );
};

export default Service;